import { ProjectOverviewApi } from "~/api/ProjectOverview";

export function useProjectOverviewApi(): ProjectOverviewApi {
  const projectOverviewApi = new ProjectOverviewApi(useHttpClient());
  return projectOverviewApi;
}
